export enum UserRole {
    USER = 'USER',
    FRACTION = 'FRACTION',
    EVENTTEAM = 'EVENTTEAM',
    WLCHECKER = 'WLCHECKER',
    STAFF = 'STAFF',
    ADMIN = 'ADMIN',
    SUPERADMIN = 'SUPERADMIN'
}

const userRole = {
    USER: 'USER',
    FRACTION: 'FRACTION',
    EVENTTEAM: 'EVENTTEAM',
    WLCHECKER: 'WLCHECKER',
    STAFF: 'STAFF',
    ADMIN: 'ADMIN',
    SUPERADMIN: 'SUPERADMIN'
}

const userRoleSelectItems = [
    {key: "USER", label: "USER"},
    {key: "FRACTION", label: "FRACTION"},
    {key: "EVENTTEAM", label: "EVENTTEAM"},
    {key: "WLCHECKER", label: "WLCHECKER"},
    {key: "STAFF", label: "STAFF"},
    {key: "ADMIN", label: "ADMIN"},
    {key: "SUPERADMIN", label: "SUPERADMIN"},
]

const userSearchBySRoleelectItems = [
    {key: "ALL", label: "ALL"},
    {key: "USER", label: "USER"},
    {key: "FRACTION", label: "FRACTION"},
    {key: "EVENTTEAM", label: "EVENTTEAM"},
    {key: "WLCHECKER", label: "WLCHECKER"},
    {key: "STAFF", label: "STAFF"},
    {key: "ADMIN", label: "ADMIN"},
    {key: "SUPERADMIN", label: "SUPERADMIN"},
]

const access = {
    adminPanel: [
        userRole.WLCHECKER,
        userRole.EVENTTEAM,
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN,
    ],
    applications: [
        userRole.WLCHECKER,
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN,
    ],
    VPPLogs: [
        userRole.ADMIN,
        userRole.SUPERADMIN,
    ],
    statiscitcs: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    logs: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    characters: [
        userRole.EVENTTEAM,
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    profiles: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    craftingEditor: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    changeRole: [
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    dailyRewardsDebug: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    radio: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    radiovoiceperm: [
        userRole.EVENTTEAM,
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    ruleseditor: [
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    announcementseditor: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    fractions: [
        userRole.EVENTTEAM,
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    fractionsusers: [
        userRole.FRACTION,
        userRole.EVENTTEAM,
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    deleteFraction: [
        userRole.ADMIN,
        userRole.SUPERADMIN
    ],
    pdaLogs: [
        userRole.STAFF,
        userRole.ADMIN,
        userRole.SUPERADMIN
    ]
}

export {
    userRole,
    access,
    userRoleSelectItems,
    userSearchBySRoleelectItems
}

